import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import { RC_LOAD_LOGIN } from '../routers/RouteConstants';
import { colors } from '../../config/static_list';



var $ = window.$;

class Header extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isLogout: false
        }
    }

    componentDidMount() {
        // Toggle min sidebar class
        $('.sidebar-main-toggle').on('click', function (e) {
            e.preventDefault();

            $('body').toggleClass('sidebar-xs').removeClass('sidebar-mobile-main');
        });
        $('.sidebar-mobile-main-toggle').on('click', function (e) {
            e.preventDefault();
            $('body').toggleClass('sidebar-mobile-main').removeClass('sidebar-mobile-secondary sidebar-mobile-right');

            if ($('.sidebar-main').hasClass('sidebar-fullscreen')) {
                $('.sidebar-main').removeClass('sidebar-fullscreen');
            }
        });
        $('.sidebar-mobile-expand').on('click', function (e) {
            e.preventDefault();
            var $sidebar = $(this).parents('.sidebar'),
                sidebarFullscreenClass = 'sidebar-fullscreen'

            if (!$sidebar.hasClass(sidebarFullscreenClass)) {
                $sidebar.addClass(sidebarFullscreenClass);
            }
            else {
                $sidebar.removeClass(sidebarFullscreenClass);
            }
        });



    }

    logout() {

        localStorage.removeItem('user');
        this.props.history.push(RC_LOAD_LOGIN);
        this.setState({
            isLogout: true
        }, () => {
            console.log(this.state.isLogout)

        })

    }

    customization() {
    }

    viewProfile() {
        this.setState({
            isLogout: true
        }, () => {
            console.log(this.state.isLogout)
        })
    }

    render() {
        var user = this.props.activeUser;
        console.log(`user`, user )
        var picture = '';
        var name = "...";

        if (Object.keys(user).length) {
            var profilePicture = user["profile_picture"];
            var defaultProfilePicture = process.env.PUBLIC_URL + "/assets/images/avatar.png";
            let text = user.accountEmail || user.accountName
            const initials = text.charAt(0).toLowerCase();
            const style = {
                backgroundColor: colors[initials],
                width: '36px',
                height: '36px',
                borderRadius: '10px',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '14px',
                fontWeight: '600',
                transition: 'transform 150ms ease, box-shadow 150ms ease'
            }

            picture =
                <span className="btn btn-icon btn-sm" style={style}>
                    <span className="letter-icon text-uppercase text-white">{initials}</span>
                </span>;

            if (typeof (profilePicture) !== "undefined" && profilePicture !== null && profilePicture !== '') {
                picture = <img src={profilePicture} onError={(e) => { e.target.onerror = null; e.target.src = defaultProfilePicture }} className="rounded-circle" alt="" style={{width: '36px', height: '36px', objectFit: 'cover', borderRadius: '10px'}} />
            }
            name = text;
        }


        return (
            // <!-- Main navbar -->
            <div style={{backgroundColor:'#FFFFFF', borderBottom:'1px solid #E2E8F0', height: '60px', backdropFilter: 'blur(12px)'}} className="navbar navbar-expand-md navbar-dark fixed-top">
                <div className="navbar-brand wmin-200 border_left_line c-nav-brand">
                    <a href="/" className="d-inline-block" style={{textDecoration: 'none'}}>
                        <div className="d-flex flex-row align-items-center">
                            <div style={{
                                width: '32px',
                                height: '32px',
                                borderRadius: '10px',
                                background: 'linear-gradient(135deg, #10B981 0%, #14B8A6 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginRight: '10px',
                                boxShadow: '0 2px 8px rgba(16, 185, 129, 0.25)'
                            }}>
                                <i className="fa fa-bolt" style={{color: '#fff', fontSize: '14px'}}></i>
                            </div>
                            <div>
                                <h5 className="mb-0 logo-style logo-outbound-colors" style={{fontSize: '16px', fontWeight: '700', letterSpacing: '-0.03em', lineHeight: '1.2'}}>
                                    <b>Outbound</b> <span className='logo-switch-colors'>Switch</span>
                                </h5>
                            </div>
                        </div>
                    </a>
                </div>

                <div className="d-md-none">
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar-mobile" style={{border: 'none', padding: '8px'}}>
                        <i className="icon-tree5" style={{color: '#94A3B8'}}></i>
                    </button>
                    <button className="header-nav-link navbar-toggler sidebar-mobile-main-toggle" type="button" style={{border: 'none', padding: '8px'}}>
                        <i style={{color:'#94A3B8'}} className="mr-2 fa fa-bars" ></i>
                    </button>
                </div>

                <div className="collapse navbar-collapse c_navbar-collapse left_boder_line" id="navbar-mobile">
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <button href="#" className="header-nav-link navbar-nav-link sidebar-control sidebar-main-toggle d-none d-md-block" style={{border: 'none', background: 'transparent', padding: '8px 12px', borderRadius: '8px', cursor: 'pointer'}}>
                                <i style={{color:'#94A3B8', fontSize: '16px'}} className="fa fa-bars"></i>
                            </button>
                        </li>
                    </ul>

                    <ul className="navbar-nav ml-auto">
                        <li className="nav-item dropdown dropdown-user text-capitalize">
                            <button className="navbar-nav-link dropdown-toggle header-nav-link" data-toggle="dropdown" style={{
                                border: 'none',
                                background: 'transparent',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                padding: '6px 12px',
                                borderRadius: '10px',
                                cursor: 'pointer',
                                transition: 'background 150ms ease'
                            }}>
                                <div className="d-none d-md-block" style={{textAlign: 'right'}}>
                                    <div style={{fontSize: '13px', fontWeight: '600', color: '#0F172A', lineHeight: '1.2', textTransform: 'capitalize'}}>{name !== '...' ? name.split('@')[0] : ''}</div>
                                    <div style={{fontSize: '11px', color: '#94A3B8', lineHeight: '1.2'}}>Admin</div>
                                </div>
                                {picture}
                            </button>

                            <div className="dropdown-menu dropdown-menu-right" style={{
                                borderRadius: '12px',
                                border: '1px solid #E2E8F0',
                                boxShadow: '0 10px 25px rgba(0,0,0,0.08), 0 4px 10px rgba(0,0,0,0.04)',
                                padding: '8px',
                                minWidth: '200px'
                            }}>
                                <div style={{
                                    padding: '8px 12px',
                                    borderBottom: '1px solid #F1F5F9',
                                    marginBottom: '4px'
                                }}>
                                    <p style={{margin: 0, fontWeight: '600', fontSize: '13px', color: '#0F172A'}}>{name}</p>
                                    <p style={{margin: 0, fontSize: '11px', color: '#94A3B8'}}>Manage your account</p>
                                </div>
                                <button className="header-nav-link dropdown-item" onClick={this.viewProfile.bind(this)} style={{
                                    borderRadius: '8px',
                                    padding: '8px 12px',
                                    fontSize: '13px',
                                    color: '#475569',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    border: 'none',
                                    width: '100%',
                                    textAlign: 'left',
                                    cursor: 'pointer',
                                    transition: 'background 150ms ease'
                                }}>
                                    <i className="fas fa-user" style={{fontSize: '12px', width: '16px', textAlign: 'center', color: '#94A3B8'}}></i>
                                    View Profile
                                </button>
                                <button className="header-nav-link dropdown-item" onClick={this.logout.bind(this)} style={{
                                    borderRadius: '8px',
                                    padding: '8px 12px',
                                    fontSize: '13px',
                                    color: '#EF4444',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    border: 'none',
                                    width: '100%',
                                    textAlign: 'left',
                                    cursor: 'pointer',
                                    transition: 'background 150ms ease'
                                }}>
                                    <i className="icon-switch2" style={{fontSize: '12px', width: '16px', textAlign: 'center'}}></i>
                                    Sign Out
                                </button>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            // <!-- /main navbar -->
        );
    }
}

function mapStateToProps({ activeUser }) {
    return { activeUser }
}

export default connect(mapStateToProps)(withRouter(Header));
